var HeaderFactory = function ($resource, $window) {
    return $resource(__baseApiUrl__ + '/participant-web-services/rest/accounts/user/profile', {},
        {
            query: {
                method: 'GET',
                isArray: false
            }
        }
    );
};

HeaderFactory.$inject = ['$resource', '$window'];
export default HeaderFactory;
